import React, { createContext, useContext, useState } from "react";

const FormValueContext = createContext();
const FormUpdateContext = createContext();

export function useFormValue() {
    return useContext(FormValueContext)
} 

export function useFormUpdate() {
    return useContext(FormUpdateContext)
} 

export function FormProvider({ children }) {
  const [formValue, setFormValue] = useState({ region: null });

  function setForm(value) {
    setFormValue(value);
  }

  return (
    <FormValueContext.Provider value={formValue}>
      <FormUpdateContext.Provider value={setForm}>
        {children}
      </FormUpdateContext.Provider>
    </FormValueContext.Provider>
  );
}
